export default __webpack_public_path__ + "b0c8c882658803a6b31f6f8389f5e281.png";